// eslint-disable no-param-reassign
import { createSlice } from '@reduxjs/toolkit';

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    restaurantId: '',
    menuId: '',
    tableId: '5f81fe7a70bce000af7e3d32', // Dummy table
    items: [],
    note: '',
    availableOrderTypes: [],
  },
  reducers: {
    add: (state, action) => {
      state.items = [
        ...state.items,
        { ...action.payload, cartItemGroupId: state.items.length + 1 || 1 },
      ];
    },
    remove: (state, action) => {
      state.items = state.items.filter(
        (item) => action.payload !== item.cartItemGroupId
      );
    },
    updateRestaurant: (state, action) => {
      state.restaurantId = action.payload.restaurantId;
      state.availableOrderTypes = action.payload.availableOrderTypes;
    },
    updateMenu: (state, action) => {
      state.menuId = action.payload.menuId;
    },
  },
});

export default cartSlice;
export const { add, remove, updateRestaurant, updateMenu } = cartSlice.actions;
